// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"9909f993","943":"6f21b6c0"}[chunkId] + ".chunk.js";
};